// TYPES FOR FREE HYPOTHESIS

import { DashDateString } from 'routes/HumanResourcesModule/business/types';

export type FreeHypothesis = {
    id: number;
    filters: FreeFilters;
    operation: OperationType;
    value: number;
    valueType: ValueType;
};
export enum ValueType {
    AMOUNT = 'amount',
    PERCENT = 'percent',
}
export enum OperationType {
    DECREASE = 'decrease',
    FIX = 'fix',
    INCREASE = 'increase',
}
// TODO add a check to see what field is required
export type FreeFilters = {
    cadreEmploi?: string;
    category?: string;
    date?: DashDateString;
    filiere?: string;
    greaterThan?: number;
    jobLabel?: string[];
    lowerThan?: number;
};

// -----types for IFSE free hypothesis only ----
export type FreeHypothesisMutationParams = {
    filters: FreeFilters;
    newValue: number;
    operation: OperationType;
    valueType: ValueType;
    agentsNumber: number;
};

export type FreeHypothesisEditMutationParams = {
    id: number;
    filters: FreeFilters;
    newValue: number;
    operation: OperationType;
    valueType: ValueType;
    agentsNumber: number;
};

export type FreeIFSEHypothesisInformation = {
    categories: string[];
    gradeLines: string[][];
};

// ------------------------------------------------
